const namespace = {} as const;

export default namespace;
